import axios from 'axios';
import Cookies from 'js-cookie';
import { goRiceUrl } from '../constant/siteConstants';
import { logOut } from '../utils/logOut';

// Tokeni almak için bir yardımcı fonksiyon
const getToken = () => Cookies.get('token');
const getRefreshToken = () => localStorage.getItem('refreshToken') || '';

// Yeni bir Axios instance oluştur
const apii = axios.create({
    baseURL: `${goRiceUrl}/api`,
    headers: {
        'Content-Type': 'application/json',
        'token': getToken()
    }
});

// Token'i isteğe ekleyen bir request interceptor
apii.interceptors.request.use(
    config => {
        const token = getToken();
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
            config.headers['token'] = token;
        }
        return config;
    },
    error => Promise.reject(error) // İstek hatası varsa olduğu gibi döndür
);

// Token yenileme fonksiyonu (401 Unauthorized durumunda kullanılacak)
const refreshToken = async () => {
    try {
        const response = await axios.post(`${goRiceUrl}/apii/refresh-token`, {
            token: getRefreshToken()
        });
        if (response.data?.token) {
            localStorage.setItem('token', response.data.token);
            return response.data.token;
        }
    } catch (error) {
        console.error("Token yenileme başarısız.");
        return null;
    }
};
let isHandling401Error = false;

const handleError = async error => {
    // Eğer response yoksa (network hatası vb.)
    if (!error.response) {
        return Promise.reject({
            message: 'Sunucuya bağlanılamıyor',
            originalError: error
        });
    }

    const { status, data } = error.response;

    // 401 Unauthorized hatası
    if (status === 401) {
        if (!isHandling401Error) {
            isHandling401Error = true;
            logOut(() => { }, false);
        }
        return Promise.reject({
            message: 'Oturum süreniz dolmuş. Lütfen tekrar giriş yapın.',
            status: 401,
            data: data
        });
    }

    // 403 Forbidden hatası
    if (status === 403) {
        return Promise.reject({
            message: 'Bu işlem için yetkiniz yok',
            status: 403,
            data: data
        });
    }

    // 404 Not Found hatası
    if (status === 404) {
        const apiUrl = error.config?.url || error.request?.responseURL || 'API';
        return Promise.reject({
            message: `İstek ucu "${apiUrl}" bulunamadı`,
            status: 404,
            data: data
        });
    }

    // 413 Request Entity Too Large hatası
    if (status === 413) {
        return Promise.reject({
            message: 'Gönderilen veri çok büyük. Lütfen dosya boyutunu küçültün.',
            status: 413,
            data: data
        });
    }

    // Backend'den gelen hata mesajını doğru şekilde parse et
    let errorMessage = 'Bir hata oluştu';
    let parsedData = data;

    // Eğer data bir Blob ise (Excel indirme gibi durumlarda), text olarak oku
    if (data instanceof Blob) {
        try {
            const text = await data.text();
            // JSON olup olmadığını kontrol et
            try {
                parsedData = JSON.parse(text);
            } catch {
                // JSON değilse text olarak kullan
                errorMessage = text || errorMessage;
                parsedData = { error: text };
            }
        } catch (blobError) {
            console.error('Blob okuma hatası:', blobError);
        }
    }

    if (parsedData && typeof parsedData === 'object') {
        // Farklı backend hata formatlarını kontrol et
        if (parsedData.error && typeof parsedData.error === 'string') {
            errorMessage = parsedData.error;
        } else if (parsedData.message && typeof parsedData.message === 'string') {
            errorMessage = parsedData.message;
        } else if (parsedData.detail && typeof parsedData.detail === 'string') {
            errorMessage = parsedData.detail;
        }
    } else if (typeof parsedData === 'string') {
        errorMessage = parsedData;
    }

    // Tam hata bilgisini return et
    return Promise.reject({
        message: errorMessage,
        status: status,
        data: parsedData,
        originalError: error
    });
};
// Response interceptor: Token yenileme işlemi ve diğer hata yönetimi
apii.interceptors.response.use(
    response => response, // Başarılı yanıtları olduğu gibi döndür
    async error => await handleError(error) // Diğer durumlar için hata yönetimi
);

export default apii;